// Navigation items for LTax project

import {
  ClientsIcon,
  DashboardIcon,
  HelpCenterIcon,
  MessagesIcon,
  ReportsIcon,
  SalesTaxReturnsIcon,
  TaxSettingsIcon,
  TransactionsIcon,
  VATReturnsIcon,
} from '../../components/MainNavigation/icons'
import { getCombinedSettingsMessageCount } from 'utils/settingsNavBadgeCount'
import { SANDBOX_FEATURE } from '../../helpers/sandboxAccess'

/**
 * Get navigation items for LTax project
 * @param {Object} context - Context object with location, t, newMessagesCount, globalState
 * @returns {Array} Array of navigation items
 */
export const getLTaxNavigationItems = (context) => {
  const { location, t, newMessagesCount = {}, globalState } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    {
      url: '/start-guide',
      label: 'Start guide',
      icon: () => <HelpCenterIcon selected={location.pathname.startsWith('/start-guide')} />,
      selected: location.pathname.startsWith('/start-guide'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/home',
      label: t('menu.home'),
      icon: () => <DashboardIcon selected={location.pathname.startsWith('/home')} />,
      selected: location.pathname.startsWith('/home'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/clients',
      label: t('menu.clients'),
      icon: () => <ClientsIcon selected={location.pathname.startsWith('/clients')} />,
      selected: location.pathname.startsWith('/clients'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/transactions',
      label: t('menu.transactions'),
      icon: () => <TransactionsIcon selected={location.pathname.startsWith('/transactions')} />,
      badge: printMessagesCount(newMessagesCount.transactions),
      selected: location.pathname.startsWith('/transactions'),
      isTaxAgentMainVisible: false,
    },
    {
      url: '/vat-returns',
      label: t('menu.vatRet'),
      icon: () => <VATReturnsIcon selected={location.pathname.startsWith('/vat-returns')} />,
      selected: location.pathname.startsWith('/vat-returns'),
      isTaxAgentMainVisible: false,
      filterCondition: () => globalState?.user?.user?.vat_returns_show_in_menu !== false,
    },
    {
      url: '/tax-returns',
      label: t('menu.salesTax'),
      icon: () => <SalesTaxReturnsIcon selected={location.pathname.startsWith('/tax-returns')} />,
      selected: location.pathname.startsWith('/tax-returns'),
      isTaxAgentMainVisible: false,
      filterCondition: () => globalState?.user?.user?.sales_tax_returns_show_in_menu !== false,
    },
    {
      url: '/reports',
      label: t('menu.reports'),
      badge: printMessagesCount(newMessagesCount['tax-audit']),
      icon: () => <ReportsIcon selected={location.pathname.startsWith('/reports')} />,
      selected: location.pathname.startsWith('/reports'),
      sandboxFeature: SANDBOX_FEATURE.REPORTS,
      isTaxAgentMainVisible: false,
    },
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      sandboxFeature: SANDBOX_FEATURE.MESSAGES,
      isTaxAgentMainVisible: true,
    },
    {
      url: '/settings',
      label: t('menu.taxSettings'),
      icon: () => <TaxSettingsIcon selected={location.pathname.startsWith('/settings')} />,
      badge: printMessagesCount(
        getCombinedSettingsMessageCount(newMessagesCount, 'merchant_settings')
      ),
      selected: location.pathname.startsWith('/settings'),
      isTaxAgentMainVisible: false,
    },
  ]
}
